import { render } from "./testitems.vue?vue&type=template&id=6b9e723e&scoped=true"
import script from "./testitems.vue?vue&type=script&lang=js"
export * from "./testitems.vue?vue&type=script&lang=js"

import "./testitems.vue?vue&type=style&index=0&id=6b9e723e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\satish\\Desktop\\WEBDEV\\assignment\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9e723e"]])

export default __exports__